import { DOCUMENT } from "@angular/common";
import { inject, Injectable } from "@angular/core";
import { RequestBodyContextBuilder } from "../builders/request-body-context.builder";
import { PolicyDetail } from "../models/policy-details";
import { PolicyWait4SignEndorsement } from "../models/policy-wait4sign-endorsement.model";
import { ContextService } from "./context.service";

@Injectable({
  providedIn: "root",
})
export class PolicyRecoveryService {
  private document = inject(DOCUMENT);

  constructor(private contextService: ContextService) {}

  getSignatureUrl(contract: PolicyDetail) {
    const requestBody = new RequestBodyContextBuilder()
      .setReferenceContrat(contract.reference)
      .setProduit(contract.productCode)
      .setBranche(contract.branchCode)
      .setCodeVendeur(contract.distributorCode)
      .setEmail(contract.email)
      .build();
    try {
      this.contextService.createContext(requestBody).subscribe({
        next: redirectUrl => {
          this.document?.defaultView?.open(redirectUrl, "_blank");
        },
        error: error => {
          console.error("Erreur lors de la création du contexte", error);
        },
      });
    } catch (error) {
      console.error("Erreur lors de la construction du requestBody", error);
    }
  }

  getSignatureUrls(contract: PolicyWait4SignEndorsement[]) {
    const requestBodyBuilder = new RequestBodyContextBuilder();
    requestBodyBuilder
      .setProduit(contract[0].productCode)
      .setBranche(contract[0].branchCode)
      .setCodeVendeur(contract[0].distributorCode)
      .setEmail(contract[0].email)
      .setAvenants(
        contract.map(c => ({
          reference: c.reference,
          branchCode: c.branchCode,
          productName: c.productName,
          distributorCode: c.distributorCode,
          email: c.email,
          correlationId: c.correlationId,
          agreementId: c.agreementId,
        }))
      );
    const requestBody = requestBodyBuilder.build();
    try {
      this.contextService.createContext(requestBody).subscribe({
        next: redirectUrl => {
          this.document?.defaultView?.open(redirectUrl, "_blank");
        },
        error: error => {
          console.error("Erreur lors de la création du contexte", error);
        },
      });
    } catch (error) {
      console.error("Erreur lors de la construction du requestBody", error);
    }
  }
}
